export const SERVICE_CARDS_DATA = [
  {
    backgroundImage: "assets/services/cpa_img.png",
    serviceAbbr: "CPA",
    serviceName: "Certified Professional Accountant",
    serviceDescription: [
      "Unlock Your Path to Success with Certified Professional Accountant (CPA) Courses!",
      "Are you ready to embark on a lucrative and rewarding career in finance? Look no further than our comprehensive CPA courses tailored to meet the dynamic demands of the Indian financial landscape.",
    ],
  },
  {
    backgroundImage: "assets/services/cgp_img.png",
    serviceAbbr: "CGP",
    serviceName: "Certified GST Practitioner",
    serviceDescription: [
      "Unlock the Gateway to Success in India's Tax Landscape with Our Certified GST Practitioner Course!",
      "Our comprehensive Certified GST Practitioner course equips you with the knowledge and skills needed to navigate the complexities of GST seamlessly.",
    ],
  },
  {
    backgroundImage: "assets/services/cat_img.png",
    serviceAbbr: "CAT",
    serviceName: "Certificate in Accounting Technician",
    serviceDescription: [
      "Unlock Your Future in Finance with our Certificate in Accounting Technician (CAT) Course!",
      "Are you ready to kickstart a rewarding career in accounting and finance? Our CAT course is your gateway to success in India's dynamic financial landscape.",
    ],
  },
  {
    backgroundImage: "assets/services/gst_img.png",
    serviceAbbr: "GST",
    serviceName: "Goods and Services Tax",
    serviceDescription: [
      "Unlock Your Potential with our Goods and Services Tax (GST) Courses!",
      "Are you ready to become a master of taxation in India? Our comprehensive GST courses are designed to equip you with the knowledge and skills needed to navigate the complex world of tax regulations and compliance effortlessly.",
    ],
  },
];

export const SERVICES_QUALIFICATIONS = [
  "Under Graduate",
  "Graduate",
  "Post Graduate",
  "Masters",
];

export const SERVICES_SECTION_NAME = "SERVICES";
export const SERVICES_TITLE = "Courses We Offer!";
